<template>
  <div>
    <!-- Primary Page Layout
    ==================================================-->

    <account-header settingName="Reservations"></account-header>
    <div class="row justify-center">
      <div class="col-lg-2"></div>
      <div class="col-lg-8">
        <h3 class="mt-4">My Reservations</h3>
        <div class="row mt-4 mb-4">
          <div class="col-md-12">
            <table class="table">
              <thead class="thead-dark">
                <tr>
                  <th scope="col">Guests</th>
                  <th scope="col">Rooms</th>
                  <th scope="col">Check In</th>
                  <th scope="col">Check Out</th>
                  <!-- <th scope="col">Action</th> -->
                </tr>
              </thead>
              <tbody>
                <tr v-for="reservation in reservations" :key="reservation.id">
                  <td>{{ reservation.guests }}</td>
                  <td>{{ reservation.rooms }}</td>
                  <td>{{ reservation.check_in }}</td>
                  <td>{{ reservation.check_out }}</td>
                  <!-- <td>
                    <button type="button" class="btn btn-info btn-sm">View</button>
                    <button type="button" class="btn btn-danger btn-sm">Remove</button>
                  </td> -->
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Constants from '@/common/Constants.js'
import accountHeader from "@/components/accountHeader.vue";
export default {
  name: "reservations",
  components: { "account-header": accountHeader },
  data(){
      return{
        reservations: {},
      }
  },
  mounted() {
    this.getUserReservations().then(data => {
      this.reservations = data.reservations;
    })
    .catch(function (error) {
        if (error.response.status == 404) {
          localStorage.clear();
          router.push('/');
        }
    });
  },
  methods: {
    getUserReservations: function(){
      let def = $.Deferred();
      let userDetails = JSON.parse(localStorage.user);
      let url = Constants.API_USER_RESERVATION_URL + userDetails.id;

      this.$http.get(url, { headers: { Authorization: "Bearer " +  localStorage.userToken }})
      .then((response) => {
        def.resolve(response.data);
      })
      .catch(function (error) {
        if (error.response) {
          def.reject(error);
        }
      });

      return def.promise();

    }
  }

  // components: {
  //   headerNav
  // }
};
</script>
